module.exports = __webpack_public_path__ + "img/course-titie-bg.24b5d51a.png";